/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentProviderResponse { 
    id?: string | null;
    name?: string | null;
    walletId?: string | null;
    isLastUsed?: boolean;
    isPinRequired?: boolean;
    destinationCode?: Array<string> | null;
    steps?: Array<string> | null;
    accountProviderId?: string | null;
}

